/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M16.9419 3.3065A16.1994 16.1994 0 0 0 12.8157 2c-.1777.3238-.3853.7593-.5285 1.1058-1.5384-.2332-3.0628-.2332-4.5729 0-.1431-.3465-.3555-.782-.5348-1.1058a16.1467 16.1467 0 0 0-4.1293 1.3097C.4389 7.2858-.269 11.1632.0849 14.9854c1.732 1.3033 3.4104 2.0949 5.0606 2.613a12.6983 12.6983 0 0 0 1.0838-1.7986 10.6289 10.6289 0 0 1-1.7067-.837 8.5524 8.5524 0 0 0 .4184-.3335c3.2908 1.5509 6.8664 1.5509 10.1179 0 .1369.1149.2769.2266.4185.3335a10.6015 10.6015 0 0 1-1.7099.8386A12.639 12.639 0 0 0 14.8513 17.6c1.6517-.5181 3.3317-1.3097 5.0637-2.6146.4153-4.431-.7094-8.2727-2.9731-11.6789ZM6.6776 12.6348c-.9878 0-1.798-.9293-1.798-2.0609 0-1.1317.7929-2.0625 1.798-2.0625 1.0053 0 1.8154.9292 1.798 2.0625.0016 1.1316-.7927 2.0609-1.798 2.0609Zm6.6447 0c-.9879 0-1.798-.9293-1.798-2.0609 0-1.1317.7928-2.0625 1.798-2.0625s1.8153.9292 1.798 2.0625c0 1.1316-.7928 2.0609-1.798 2.0609Z"
  />,
  'SidebarDiscord'
);
